import { PaymentStatus } from '@repo/common';
import { Card } from '@repo/shadcn';

import { SectionDataTable } from '@components/ui';
import { SelectFilter, TextSearchFilter } from '@components/ui/search-filter';

import { useUrlFilter } from '@/hooks';
import { usePurchaseList } from '@/modules/purchase/purchase-list/purchase-list.hook';
import { purchaseTableColumns } from '@/modules/purchase/purchase-list/purchase-table.column';
import { PAYMENT_STATUS_FILTER_KEY } from '@/modules/sales/order-list/constant';

import { useSupplierDetails } from './hook';

export const PurchaseHistory = () => {
    const { setSearchText, searchText, setSearchFilter, getSearchFilter } =
        useUrlFilter();
    const { supplierId } = useSupplierDetails();

    const paymentStatusFilter =
        getSearchFilter(PAYMENT_STATUS_FILTER_KEY) || '';

    const { data, isLoading, isFetching } = usePurchaseList({ supplierId });

    return (
        <Card className="min-w-0 space-y-4 overflow-hidden p-3 sm:p-4">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
                <h3 className="text-lg font-medium">Purchase History</h3>
                <div className="grid w-full grid-cols-1 gap-2 sm:grid-cols-2 lg:w-auto">
                    <div className="min-w-0 [&_input]:!w-full">
                        <TextSearchFilter
                            placeholder={'Search purchases'}
                            onChangeSearch={(e) =>
                                setSearchText(e.target.value)
                            }
                            value={searchText}
                        />
                    </div>
                    <SelectFilter
                        className="w-full lg:w-auto [&_[role=combobox]]:!w-full"
                        placeholder={'Payment Status'}
                        onChange={(value) =>
                            setSearchFilter(PAYMENT_STATUS_FILTER_KEY, value)
                        }
                        value={paymentStatusFilter}
                        options={[
                            { label: 'Paid', value: PaymentStatus.PAID },
                            { label: 'Due', value: PaymentStatus.DUE },
                        ]}
                    />
                </div>
            </div>
            <div className="min-w-0 [&_[role=navigation]>ul]:min-w-max [&_[role=navigation]]:justify-start [&_[role=navigation]]:overflow-x-auto sm:[&_[role=navigation]]:justify-center">
                <SectionDataTable
                    columns={purchaseTableColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </div>
        </Card>
    );
};

PurchaseHistory.displayName = 'PurchaseHistory';
